export default __webpack_public_path__ + "tmp_src/components/SiteHeader/SiteHeader~aurora.css.liquid";